import axios from "axios";
import { Pencil, Trash2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import EditUserPopup from "./EditUserPopup";
// ...existing code...
import DeleteSuccessModal from "../Components/DeleteSuccessModal";
import Loader from "../common/Loader";
import { API_BASE_URL } from "../config/constants";
import { jwtDecode } from "jwt-decode";

export default function UserAccess() {
  const [users, setUsers] = useState([]);
  const [loader, setLoader] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteUserData, setDeleteUserData] = useState(null);
  const [successPopup, setSuccessPopup] = useState(false);


  const onHandleDeleteUSer = async () => {
    try {
      await axios.delete(`${API_BASE_URL}/delete-user/${deleteUserData?.id}`);
      setDeleteUserData(null);
      setShowDeleteModal(false);
      fetchUsers(); // Refresh list
    } catch (err) {
      alert("Delete failed: " + err.message);
    }
  };


  const fetchUsers = async () => {
    try {
      setLoader(true);
      setOpenPopup(false);

      const token = localStorage.getItem("token");
      let deviceId = null;
      if (token) {
        const decoded = jwtDecode(token);
        deviceId = decoded.deviceId;
      }

      const res = await axios.get(`${API_BASE_URL}/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
           "deviceid": localStorage.getItem("deviceId"),
        },
      });

      // ✅ Set all users at once
      setUsers(res.data);

      setLoader(false);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  useEffect(() => {
    fetchUsers(); // Run on page load
  }, []);

  const handleDelete = async (data) => {
    setDeleteUserData(data);
    setShowDeleteModal(true);

  };

  const getSites = (user) => {
    const siteNames = user?.sites?.map((s) => s.siteName).join(", ") || "";
    // console.log("sitename", siteNames);
    return siteNames;
  };
  return (
    <div className="ml-[5.5rem]">
      <div className="text-[1.3333rem] font-semibold not-italic text-white mt-[4.5625rem] pb-[0.5625rem]">User Access</div>
      <div className="opacity-60 font-poppins font-normal not-italic text-[1rem] text-white mb-[2.0625rem]"></div>

      {loader ? (
        <Loader />
      ) : (
        <div className="mr-[6.5625rem] h-[45.625rem] relative">
          <div className="absolute inset-0 overflow-y-auto pr-2 rounded">
            <div className="overflow-hidden rounded-[20px] border border-[#EAECF03B] bg-[#072A27]">
              <table className="w-full border border-[#EAECF03B] rounded-2xl table-fixed border-seprate">
                <thead className="sticky top-0 z-20">
                  <tr className="bg-[#0A3D38]">
                    {[
                      "Email",
                      "First Name",
                      "Role",
                      "Sites",
                      "Status",
                      "Actions",
                    ].map((head, i) => (
                      <th
                        key={i}
                        className="py-[1rem] px-[2rem] text-[1rem] font-medium not-italic leading-[1.5rem] text-left text-white border-b border-[#EAECF03B]"
                      >
                        {head}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {users.map((row, i) => {
                    const rowBg = i % 2 === 0 ? "bg-[#072A27]" : "bg-[#08302D]";
                    return (
                      <tr key={i} className={`${rowBg} border-b border-[#EAECF03B] last:border-b-0`} >
                        <td className="w-[17rem] h-[6rem] text-[1.167rem] leading-[1.667rem] font-normal not-italic py-[1.3125rem] px-8 truncate text-white opacity-60">
                          {row.email}
                        </td>
                        <td className="w-[12.75rem] h-[6rem] text-[1.167rem] leading-[1.667rem] font-normal not-italic py-[1.3125rem] px-8 truncate text-white opacity-60">
                          {row.firstName ||  row.email?.split("@")[0] || "-"}
                        </td>
                        <td className="w-[12.75rem] h-[6rem] text-[1.167rem] leading-[1.667rem] font-normal not-italic py-[1.3125rem] px-8 truncate text-white opacity-60">
                          {
  row.roleId === 1
    ? "Super Admin"
    : row.roleId === 2
    ? "Admin"
    : row.roleId === 3
    ? "User"
    : "-"
}
                        </td>
                        <td className="w-[15.5rem] h-[6rem] text-[1.167rem] leading-[1.667rem] font-normal not-italic py-[1.3125rem] px-8 text-white truncate overflow-hidden whitespace-nowrap opacity-60">
                          {getSites(row)|| "-"}
                        </td>
                        <td className="w-[12.75rem] h-[6rem] text-[1.167rem] leading-[1.667rem] font-normal not-italic py-[1.3125rem] px-8 truncate text-white opacity-60">
                          {row.isActive === false  ? "Inactive" : "Active"}
                        </td>
                        <td className="w-[12.75rem] h-[6rem] py-[1.3125rem] px-8 text-white">
                          <div className="flex items-center gap-3">
                            <Trash2
                              size={18}
                              className="cursor-pointer text-white"
                              onClick={() => handleDelete(row)}
                            />
                            <Pencil
                              size={18}
                              className="cursor-pointer text-white"
                              onClick={() => {
                                setSelectedUser(row);
                                setOpenPopup(true);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

        </div>


      )}

      <EditUserPopup
        open={openPopup}
        user={selectedUser}
        onClose={() => fetchUsers()}
        onSuccess={() => setSuccessPopup(true)}
      />

      {successPopup && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50 bg-black/50 backdrop-blur-md">
          <div className="relative bg-[#051E1C] rounded-xl flex flex-col items-center shadow-lg w-[49.92rem] h-[20.58rem]">
            <button
              onClick={() => setSuccessPopup(false)}
              className="absolute top-6 right-8 text-white/70 hover:text-white text-lg"
            >
              ✕
            </button>

            <div className="mt-[6rem] mx-[-22.8125rem] flex items-center justify-center rounded-full">
              <img src="assets/tick-icon.svg" alt="Tick Icon" className="w-[4.33rem] h-[4.33rem]" />
            </div>

            <p className="text-white font-poppins text-center text-[1.33rem] leading-[2rem] font-semibold pt-[2.25rem] pb-[6rem]">
              User Details Updated Successfully
            </p>
          </div>
        </div>
      )}

      <DeleteSuccessModal
        username="xytz"
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        deleteUserData={deleteUserData}
        onHandleChange={onHandleDeleteUSer}
      />
    </div>

  );
}
